export const isEmailDuplicate = ({ email, key }, signatories) => signatories.some(signatory => signatory.email.toLocaleLowerCase() === email.toLocaleLowerCase() && signatory.key !== key);
